import React, { useEffect, useRef, useState } from 'react';
import './player-teams-view.styles.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { getQueryFromRtDb, getUniqueDocumentFromFirestore } from '@/utils/getDataFromDbSimplified';
import TeamViewContent from '@/components/MANAGE-GAME/teams/team-view-content.component';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';

const PlayerTeamsView = ({
  gameData,
  playerData,
  teamMembers
}) => {

  const [playerTeams, setPlayerTeams] = useState([]);
  const [ playerList, setPlayerList ] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const teamRef = useRef({});
  const playerRef = useRef({});
  let teamListenerArr = [];

  useEffect(() => {

    return () => {
      if (teamListenerArr.length > 0) {
        teamListenerArr.forEach(listener => listener());
      }
    }
  }, [])

  useEffect(() => {
    if (!teamMembers || !playerData) return;
    const teamIds = Object.values(teamMembers)
      .filter(t => t.members.includes(playerData.playerId))
      .map(t => t.teamId);
    console.log(teamIds);
    getTeamData(teamIds);
  }, [teamMembers, playerData])

  function getTeamData(teamIds) {
    if (location.pathname.includes('/preview/player/')) {
      const teamInfoArr = Object.values(completePlayerData)
        .filter(p => teamIds.includes(p.playerId));
      setPlayerTeams(teamInfoArr);
      for (let team of teamInfoArr) {
        getPlayerList(team);
      }
      return;
    }
    for (let teamId of teamIds) {
      getUniqueDocumentFromFirestore({
        'path': `games/${gameData.gameId}/players/${teamId}`,
        'callback': callback,
        'handleListener': handleListener
      })
    }
    function callback(data) {
      teamRef.current = {
        ...teamRef.current,
        ...{ [data.playerId]: data }
      }
      console.log(teamRef.current);
      setPlayerTeams(Object.values(teamRef.current));
      getPlayerList(data);
    }
    function handleListener(listener) {
      teamListenerArr.push(listener);
    }
  }

  function getPlayerList(team) {
    if (location.pathname.includes('/preview/player/')) {
      for (let playerId of team.opt_members) {
        const playerInfo = completePlayerData[playerId];
        console.log(playerInfo);
        if (playerInfo) {
          playerRef.current = {
            ...playerRef.current,
            ...{ [playerId]: playerInfo }
          }
        }
      }
      setPlayerList({ ...playerRef.current });
      return;
    }
    for (let playerId of team.opt_members) {
      getQueryFromRtDb({
        'path': `games/${team.gameId}/playerDocs/${playerId}`,
        'callback': callback,
        'once': true
      })
      function callback(data) {
        playerRef.current = {
          ...playerRef.current,
          ...{ [data.playerId]: data }
        }
        setPlayerList({ ...playerRef.current });
      }
    }
  }

  return (
    <div className='player-teams-view'>
      <div className='player-teams-content g-card'>
        {/* <BackButton cancel={() => navigate(-1)} />
        <div className='g-space-1'></div> */}
        <div className='player-title'>
          <ImageContainer
            src='/images/icons/groups.png'
            alt='teams icon'
            className='player-title-icon' />
          Your Teams
        </div>
        <hr />
        {
          playerTeams.length > 0 ?
            playerTeams
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((team, index) => {
              return (
                <div
                  key={team.playerId}
                  className='team-content-container'>
                  <TeamViewContent
                    gameData={gameData}
                    teamData={team}
                    playerList={playerList} />
                  {
                    (index !== playerTeams.length - 1) &&
                    <div>
                      <div className='g-space-2'></div>
                    <hr />
                    <div className='g-space-1'></div>
                    </div>
                  }
                </div>
              )
            })
            :
            <div>No teams found.</div>
        }
      </div>
    </div>
  )
}

export default PlayerTeamsView